import Flex from '@creditflowresearch/uilib/Flex';
import PresetTag from '@creditflowresearch/uilib/PresetTag';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import withDraftSync from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/withDraftSync';
import usePresets from './usePresets';

import styles from '@/creditflowresearch/ui/components/bondscreener/CustomizationPanel/customizationPanel.module.scss';

const CustomizationPanelPresetsBase = () => {
  const presets = usePresets();

  return (
    <Flex align="center" gap={ 8 } className={ styles.presets } dataTest="customizationPanelPresets">
      <span className={ styles.presetsLabel }>Presets:</span>
      { presets.map((preset) => (
        <Tooltip key={ preset.id } content={ preset.tooltip }>
          <PresetTag
            isActive={ preset.isActive }
            onClick={ preset.toggle }
            dataTest={ `customizationPanelPreset-${ preset.id }` }
          >
            { preset.label }
          </PresetTag>
        </Tooltip>
      )) }
    </Flex>
  );
};

export const CustomizationPanelPresets = withDraftSync(CustomizationPanelPresetsBase);
